export class CookieController {
    constructor() {
        var cookie = document.querySelector('.toggle-tarte-citron');
        if (cookie){
            cookie.addEventListener('click',function () {
                document.querySelector('#tarteaucitron').style.display="block";
            });
        }
    }
}